<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-3">
          <div class="mt-4 mt-lg-0">
            <h4 class="card-title">Unit</h4>
            <v-select :options="activeUnits" :reduce="unit => unit.docID" label="name" v-model="searchUnit" multiple></v-select>
          </div>
        </div>
        <div class="col-lg-3">
          <h4 class="card-title">Start Date</h4>
          <date-picker v-model="searchStartDate" :first-day-of-week="1" lang="en"></date-picker>
        </div>
        <div class="col-lg-3">
          <h4 class="card-title">End Date</h4>
          <date-picker v-model="searchEndDate" :first-day-of-week="1" lang="en"></date-picker>
        </div>
      </div>
      <!-- end row -->
      <div class="row mt-3 float-right">
        <div class="col-12">
          <b-button id="btn_search" variant="primary" v-on:click="search()">Generate</b-button>
        </div>
      </div>
      <!-- en row -->
    </div>
  </div>
  <!-- end card -->
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import { getWorkOrdersWithConditions } from '../../../../helper/dbHelpers';


  export default {
    props: {
      units: Array,
    },
    components: {
      DatePicker
    },
    data (){
      return {
        searchUnit: null,
        searchStartDate: null,
        searchEndDate: null
      }
    },
    methods: {
      search: async function (){
        // query and filter data based on search parameters then emit the data to the parent so the parent can display it in the table
        let startDate = this.searchStartDate;
        let endDate = this.searchEndDate;
        if (startDate === null) {
          startDate = new Date('2020-01-01');
        }
        if (endDate === null) {
          endDate = new Date('2999-01-01');
        }
        let querySnapshot = await getWorkOrdersWithConditions(this.searchUnit, startDate, endDate, null, false);

        let filteredData = [];
        querySnapshot.forEach((doc) => {
          if(doc.data().repairs.find((x) => x.documentStatus === null)){
            doc.data().repairs.forEach((repair)=>{
              if(repair.documentStatus === null && repair.completed === false){
                repair.repairedBy.forEach((rep)=>{
                  if(rep.id){
                    rep['date'] = rep.date.toDate();
                  }
                  });
                  if(repair.documents){
                    repair.documents.forEach((document) => {
                      if(document.url){
                        document['date'] = document.date.toDate();
                      }
                    })
                  }
                  repair['workOrderNumber'] = doc.data().number;
                  repair['workOrderID'] = doc.id;
                  repair['workOrderDate'] = doc.data().date.toDate();
                  if(repair['_showDetails']){
                    repair['_showDetails'] = false;
                  }
                  // we do this because older repairs added via the mobile app were missing the units field
                  repair['workOrderUnits'] = doc.data().units ? doc.data().units : [];

                  filteredData.push(repair);
              }
            });
          }
        });

        this.$emit('filtered-wo-data', filteredData);
      }
    },
    computed: {
      activeUnits(){
        return this.units.filter(unit => !unit.dateDeactivated);
      },
    },
    mounted: function (){
      let currentDate = new Date()
      let sixMonthsAgo = new Date(currentDate);
      sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
      this.searchStartDate = sixMonthsAgo;
    }
  }
</script>
